import type { AiChatMessage, CopilotScope } from "@productlane/lib/src/ai"
import { copilotScopeKey } from "@productlane/lib/src/ai"

// Server history lands after the composer is already on screen, so it goes in
// front of whatever the user authored in the meantime, deduped by id.
export function mergeHydratedHistory(
	history: AiChatMessage[],
	current: AiChatMessage[] | null,
): AiChatMessage[] {
	const existing = current ?? []
	const existingIds = new Set(existing.map((m) => m.id))
	return [...history.filter((m) => !existingIds.has(m.id)), ...existing]
}

export function shouldAdoptExistingSidebarChatState({
	scope,
	storeScope,
	messages,
}: {
	scope: CopilotScope
	storeScope: CopilotScope | null
	messages: AiChatMessage[] | null
}): boolean {
	if (!storeScope || messages === null) return false
	return copilotScopeKey(storeScope) === copilotScopeKey(scope)
}
